export default function initHeaderIntro() {
    if (document.querySelector('header.intro')) {
        new HeaderIntro(document.querySelector('header.intro'));
    }
}

/**
 * @param {HTMLElement} $el HTML Element
 */
class HeaderIntro {
    constructor($el) {
        this.$el = $el;
        this.init();
    }

    init() {
        // Ouverture du menu Profil au click sur la bubble profil (initiales ou img)
        const bubbleProfil = this.$el.querySelector('.js-show-profil-actions');
        const actionsPanel = this.$el.querySelector('.js-profil-actions');
       
        bubbleProfil.addEventListener('click', (evt) => {
            evt.preventDefault();
            actionsPanel.classList.toggle('visible');
        });

        // Ferme le panel quand on clique à l'extérieur de celle-ci
        document.addEventListener('click', (evt) => {
            if (actionsPanel.classList.contains('visible') && evt.target !== bubbleProfil && evt.target !== actionsPanel) {
                actionsPanel.classList.remove('visible');
            }
        });
    }
}
